export default {
  SEM_ACAO: 0,
  FOLLOW_UP: 1,
  PRODUTO: 2,
  RESPONSAVEL: 3
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/collumns/columnEvents.js